require('./ruleConditionGroup.i18n.json');
require('./ruleConditionGroup.tpl.html');
require('./ruleConditionGroupController.js');

const RuleConditionGroupComponent = {
    templateUrl: '/common/rule/ruleConditionGroup/ruleConditionGroup.tpl.html',
    controller: 'ruleConditionGroupController',
    bindings: {
        ruleConditionGroup: '<',
        isTopLevel: '<',
        onDeleteGroup: '&',
        canUserManageFormRules: '<',
        defaultFormTemplateUniqueName:'<'
    }
};

angular.module('ums')
    .component('uiRuleConditionGroup', RuleConditionGroupComponent);
